import TracePage from "./TracePage";

export default function Trace({ setAuth, setUserOrg }) {
  return (
    <div className="flex">
      <TracePage />
    </div>
  );
}
